import { Charge } from 'interfaces';

export const getVisibleCharges: (charges: Charge[]) => Charge[] = charges =>
   charges.filter(charge => !charge.hidden);
